import type { Control, FieldPath, FieldValues } from 'react-hook-form'
import FormDateField from './FormDateField'
import FormTimeSelectField from './FormTimeSelectField'

interface FormDateTimeFieldProps<T extends FieldValues> {
  control: Control<T>
  dateName: FieldPath<T>
  timeName: FieldPath<T>
  /** Satırın görünen başlığı. */
  label: string
  /** Tarih kutusunun erişilebilir adı (görsel olarak gizli). */
  dateLabel: string
  /** Saat kutusunun erişilebilir adı (görsel olarak gizli). */
  timeLabel: string
  required?: boolean
  minDate?: Date
  /** Tarih ya da saat kullanıcı tarafından değiştirildiğinde (form `reset`'inde değil). */
  onValueChange?: () => void
  /** Yalnız tarih kutusunu kilitler; saat düzenlenebilir kalır. */
  dateDisabled?: boolean
}

/**
 * Tarih + saat satırı: "Başlangıç saati: [tarih][saat]". İki ayrı form alanıdır, her biri kendi
 * hatasını gösterir. Görünen başlık `<legend>`'dadır; kutuların etiketleri yalnız ekran okuyucu içindir.
 */
export default function FormDateTimeField<T extends FieldValues>({
  control,
  dateName,
  timeName,
  label,
  dateLabel,
  timeLabel,
  required,
  minDate,
  onValueChange,
  dateDisabled,
}: Readonly<FormDateTimeFieldProps<T>>) {
  return (
    <fieldset className="ui-datetime">
      <legend className="ui-field-label">
        {label} {required && <span className="ui-req">*</span>}
      </legend>
      <div className="ui-datetime-controls">
        <FormDateField
          control={control}
          name={dateName}
          label={dateLabel}
          hideLabel
          minDate={minDate}
          onValueChange={onValueChange}
          disabled={dateDisabled}
        />
        <FormTimeSelectField
          control={control}
          name={timeName}
          label={timeLabel}
          hideLabel
          onValueChange={onValueChange}
        />
      </div>
    </fieldset>
  )
}
